module.exports = __webpack_public_path__ + "media/src/assets/dj-boggs-65ddbc1358f863a4f5605730841dadab.png";